import { SearchKpiRequest } from "../redux/slice/dashboard/dashboardSlice";
import { http } from "./http";
import { FETCH_ACTIVE_PRACTICE_DATA, FETCH_ACTIVE_USERS_DATA, FETCH_IVR_BREAKDOWN_DATA, FETCH_MONTHLY_IVR_TWELVE_MONTH_DATA, FETCH_MONTHLY_ORDERS_TWELVE_MONTH_DATA, FETCH_ORDER_BREAKDOWN_DATA, FETCH_TOTAL_PATIENTS_DATA, FETCH_WEEKLY_ORDERS_DATA, FETCH_WEEKLY_RECORD_TX_DATA, FETCH_WEEKLY_SALES_DATA, GET_ACTIVE_PRACTICES_DETAILS_LIST, GET_ACTIVE_USERS_DETAILS_LIST, GET_WEEKLY_SALES_DETAILS_LIST } from "./URL";

export const getActiveUsersKPIData = async (headers: Record<string, string>) => {
    try {
        const response = await http.get(`${FETCH_ACTIVE_USERS_DATA}`, { headers: { ...headers } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const getActivePracticesKPIData = async (headers: Record<string, string>) => {
    try {
        const response = await http.get(`${FETCH_ACTIVE_PRACTICE_DATA}`, { headers: { ...headers } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const getTotalPatientsKPIData = async (headers: Record<string, string>) => {
    try {
        const response = await http.get(`${FETCH_TOTAL_PATIENTS_DATA}`, { headers: { ...headers } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const getWeeklySalesKPIData = async (headers: Record<string, string>) => {
    try {
        const response = await http.get(`${FETCH_WEEKLY_SALES_DATA}`, { headers: { ...headers } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const getWeeklyOrdersKPIData = async (headers: Record<string, string>) => {
    try {
        const response = await http.get(`${FETCH_WEEKLY_ORDERS_DATA}`, { headers: { ...headers } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const getOrderBreakdownData = async (headers: Record<string, string>) => {
    try {
        const response = await http.get(`${FETCH_ORDER_BREAKDOWN_DATA}`, { headers: { ...headers } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const getIvrBreakdownData = async (headers: Record<string, string>) => {
    try {
        const response = await http.get(`${FETCH_IVR_BREAKDOWN_DATA}`, { headers: { ...headers } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const getMonthlyOrderCountsTwelveMonths = async (headers: Record<string, string>) => {
    try {
        const response = await http.get(`${FETCH_MONTHLY_ORDERS_TWELVE_MONTH_DATA}`, { headers: { ...headers } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const getMonthlyIvrCountsTwelveMonths = async (headers: Record<string, string>) => {
    try {
        const response = await http.get(`${FETCH_MONTHLY_IVR_TWELVE_MONTH_DATA}`, { headers: { ...headers } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const getWeeklyRecordTxPercentage = async (headers: Record<string, string>) => {
    try {
        const response = await http.get(`${FETCH_WEEKLY_RECORD_TX_DATA}`, { headers: { ...headers } });
        return response;
    } catch (error) {
        throw error;
    };
};

// CS-1629 - START

export const getActiveUsersKPIDetailsList = async (data: SearchKpiRequest) => {
    const response = await http.post(GET_ACTIVE_USERS_DETAILS_LIST, data);
    // CS-1984: guard the unwrap — the two lines below threw TypeError on { data: null }/undefined
    // const v3Response = response.data;
    // const resData = v3Response.data;
    const v3Response = response?.data;          // CS-1984
    const resData = v3Response?.data ?? null;   // CS-1984: safe default instead of crashing on null body
    return resData;
};

export const getActivePracticesKPIDetailsList = async (data: SearchKpiRequest) => {
    const response = await http.post(GET_ACTIVE_PRACTICES_DETAILS_LIST, data);
    const v3Response = response.data;
    return v3Response;
};

export const getWeeklySalesKPIDetailsList = async (data: SearchKpiRequest) => {
    const response = await http.post(GET_WEEKLY_SALES_DETAILS_LIST, data);
    const v3Response = response.data;
    return v3Response;
};

// CS-1629 - END